module.exports = __webpack_public_path__ + "static/media/unplugging.ebba9cf6.mp4";